import { takeLatest, put, call } from 'redux-saga/effects';

import { listBaixaManualEstoque } from '../service';
import {
  TABLE_BAIXAR_MANUAL_ESTOQUE,
  TABLE_BAIXAR_MANUAL_ESTOQUE_PENDING,
  TABLE_BAIXAR_MANUAL_ESTOQUE_SUCCESS,
  TABLE_BAIXAR_MANUAL_ESTOQUE_FAILURE
} from '../actionTypes';

function* sagaListBaixaManualEstoque(action) {
  yield put({ type: TABLE_BAIXAR_MANUAL_ESTOQUE_PENDING })

  try {
    const table = yield call(listBaixaManualEstoque, action.args)
    yield put({ type: TABLE_BAIXAR_MANUAL_ESTOQUE_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_BAIXAR_MANUAL_ESTOQUE_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListBaixaManualEstoque() {
  yield takeLatest(TABLE_BAIXAR_MANUAL_ESTOQUE, sagaListBaixaManualEstoque)
}